import { path } from "./path";

import type { ILoaderData } from "@pages/panelPages/hf/hfForm";
import type { IExtendedRouteObject } from "@routes/types.ts";
import { useUIStore } from "@/stores/uiStore";

// these are excluded from production
export const hfRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.hfList.route,
      lazy: () => import("@pages/panelPages/hf/hfList"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.hfManagement", [], "index", "main");
        return {};
      },
    },
    permissions: ["super-admin", "admin"],
  },
  {
    route: {
      path: path.hfView.route,
      lazy: () => import("@pages/panelPages/hf/hfForm"),
      loader: ({ params, request }): ILoaderData => {
        useUIStore.getState().setPage(
          request,
          "pageTitle.hfView",
          [
            {
              title: "pageTitle.hfManagement",
              url: path.hfList.link(),
            },
          ],
          "view",
        );
        return { mode: "view", id: params.id! };
      },
    },
    permissions: ["super-admin", "admin"],
  },
  {
    route: {
      path: path.hfEdit.route,
      lazy: () => import("@pages/panelPages/hf/hfForm"),
      loader: ({ params, request }): ILoaderData => {
        useUIStore.getState().setPage(
          request,
          "pageTitle.hfEdit",
          [
            {
              title: "pageTitle.hfManagement",
              url: path.hfList.link(),
            },
          ],
          "edit",
        );
        return { mode: "edit", id: params.id! };
      },
    },
    permissions: ["super-admin"],
  },
  {
    route: {
      path: path.hfCreate.route,
      lazy: () => import("@pages/panelPages/hf/hfForm"),
      loader: ({ request }): ILoaderData => {
        useUIStore.getState().setPage(
          request,
          "pageTitle.hfRegister",
          [
            {
              title: "pageTitle.hfManagement",
              url: path.hfList.link(),
            },
          ],
          "create",
        );
        return { mode: "create" };
      },
    },
    permissions: ["super-admin"],
  },
];
